import React from 'react';
import { Grid } from '@material-ui/core';
import Table from '../Table';
import { COLUMNS } from '../OrderDetailsPage/OrderItems/constants';

function OrderItems({ order, callbacks }) {
    return (
        <Grid container className="overflow-auto h-100">
            <Table
                columns={COLUMNS}
                data={(order.itemsByOrderId || []).map((item) => ({ ...item, order }))}
                callbacks={{
                    ...callbacks,
                    getRowId: (row) => row.item_id,
                }}
            />
        </Grid>
    );
}

export default OrderItems;
